import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMobileNavi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#263E6A"
      fillRule="evenodd"
      d="M22.701 16.455c.685 0 1.246.514 1.295 1.177l.004.095C24 18.43 23.419 19 22.701 19H1.3A1.283 1.283 0 0 1 0 17.727c0-.703.581-1.273 1.299-1.273zm0-5.728c.685 0 1.246.515 1.295 1.177L24 12c0 .703-.581 1.273-1.299 1.273H1.3A1.283 1.283 0 0 1 0 12c0-.703.581-1.273 1.299-1.273zm0-5.727c.685 0 1.246.515 1.295 1.177l.004.096c0 .703-.581 1.272-1.299 1.272H1.3A1.283 1.283 0 0 1 0 6.273C0 5.57.581 5 1.299 5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMobileNavi;
